import React from 'react';
import ReactInputMask from 'react-input-mask';

import { TextField, FormControl, FormHelperText } from '@material-ui/core';
import { useField } from '@unform/core';
import PropTypes from 'prop-types';

export default function InputText({
  mask,
  placeholder,
  name,
  label,
  getValue,
  serialize,
}) {
  const inputRef = React.useRef(null);

  const { fieldName, defaultValue, registerField, error } = useField(name);

  // change input
  const handleChangeInput = React.useCallback(({ target }) => {
    const { value } = target;

    inputRef.current.value = serialize(value);
    getValue(serialize(value));
  }, []);

  React.useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName]);

  React.useEffect(() => {
    inputRef.current.value = defaultValue || '';
  }, [defaultValue]);

  return (
    <FormControl style={{ width: '100%' }}>
      <ReactInputMask
        ref={inputRef}
        mask={mask}
        maskChar={placeholder}
        onChange={handleChangeInput}
        formatChars={{
          'd': '[0-9,.]',
          '9': '[0-9]',
          'a': '[A-Za-z]',
          '*': '[A-Za-z0-9]'

        }}
      >
        {(inputProps) => (
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
            label={label}
            error={!!error}
            defaultValue={defaultValue}
            {...inputProps}
          />
        )}
      </ReactInputMask>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
}

InputText.propTypes = {
  mask: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  getValue: PropTypes.func,
  serialize: PropTypes.func,
};

InputText.defaultProps = {
  mask: '',
  getValue: () => undefined,
  serialize: (value) => value,
  placeholder: '_',
};
